var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("activator",null,null,_vm.activator),_vm._v(" "),(_vm.showDialog)?_c('div',{staticClass:"report-dialog"},[_c('div',{staticClass:"card report-card"},[_vm._t("default")],2)]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }